import { firebaseApp } from "../config/firebase-config";
import {
  getFirestore,
  collection,
  doc,
  setDoc,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  orderBy,
  serverTimestamp,
} from "firebase/firestore";

const FIRESTORE_DB_ID = (process.env.REACT_APP_FIRESTORE_DB_ID || "(default)").trim();
const RAW_ORDERS_COLLECTION =
  (process.env.REACT_APP_ORDERS_COLLECTION || "orders").trim() || "orders";
const ORDERS_COLLECTION = RAW_ORDERS_COLLECTION.includes("/")
  ? "orders"
  : RAW_ORDERS_COLLECTION;

const initFirestore = () => {
  try {
    if (FIRESTORE_DB_ID && FIRESTORE_DB_ID !== "(default)") {
      return getFirestore(firebaseApp, FIRESTORE_DB_ID);
    }
    return getFirestore(firebaseApp);
  } catch (error) {
    console.warn(
      `[firebase] Could not initialize Firestore database "${FIRESTORE_DB_ID}", falling back to default.`,
      error
    );
    return getFirestore(firebaseApp);
  }
};

const firestore = initFirestore();
const ordersCollection = collection(firestore, ORDERS_COLLECTION);

const normalizeOrderDoc = (snap) => {
  const data = snap.data() || {};
  return {
    id: snap.id,
    email: data.email || "",
    address: data.address || {},
    items: Array.isArray(data.items) ? data.items : [],
    subtotal: data.subtotal || 0,
    total: data.total || 0,
    payment: data.payment || {},
    status: data.status || "uj",
    emailStatus: data.emailStatus || "pending",
    emailError: data.emailError || null,
    meta: data.meta || null,
    createdAt: data.createdAt?.toMillis ? data.createdAt.toMillis() : data.createdAt || null,
    updatedAt: data.updatedAt?.toMillis ? data.updatedAt.toMillis() : data.updatedAt || null,
  };
};

export const createOrderRecord = async (payload) => {
  const docRef = doc(ordersCollection);
  const clean = {
    ...payload,
    status: payload.status || "uj",
    emailStatus: payload.emailStatus || "pending",
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  };
  await setDoc(docRef, clean);
  const saved = await getDoc(docRef);
  return normalizeOrderDoc(saved);
};

export const fetchOrdersOnce = async () => {
  try {
    const q = query(collection(firestore, ORDERS_COLLECTION), orderBy("createdAt", "desc"));
    const snap = await getDocs(q);
    return snap.docs.map(normalizeOrderDoc);
  } catch (err) {
    console.error("[firebase] fetchOrdersOnce failed:", err);
    return [];
  }
};

export const subscribeToOrders = (onData, onError) => {
  try {
    const q = query(collection(firestore, ORDERS_COLLECTION), orderBy("createdAt", "desc"));
    return onSnapshot(
      q,
      (snapshot) => {
        const list = snapshot.docs.map(normalizeOrderDoc);
        onData?.(list);
      },
      (err) => {
        console.error("[firebase] Orders subscription failed:", err);
        onError?.(err);
      }
    );
  } catch (err) {
    console.error("[firebase] Could not subscribe to orders:", err);
    onError?.(err);
    return () => {};
  }
};
